import ReactPlayer from "react-player";
const Vision = () => {
  const video =
    "https://res.cloudinary.com/duhd0zz4q/video/upload/v1700738668/the-oil-rig-uses-machines-drills-and-pipes-to-ext-2021-11-10-13-49-31-utc_crgubv.mp4";
  return (
    <div className="bg-[#081022]">
      <div className="mx-[3%] md:mx-[5%] xl:mx-[8%] lg:py-[110px] md:py-[80px] py-[60px] ">
        <h1 className="lg:text-[65px] sm:text-[55px] text-[40px] leading-[74px] font-Suisse font-semibold text-[#4A81FF] lg:text-left text-center lg:mb-12 mb-12">
          Vision
        </h1>
        <div className="lg:w-[70%] w-full">
          <p className="md:text-[18px] text-[16px] leading-[27px] text-[#9FAAC1] font-normal font-Suisse lg:text-left text-center">
            "Our vision is to be a globally recognized and trusted leader in
            multi-sector trading, representing excellence, integrity, and
            sustainability. We aspire to continually expand our presence in
            diverse markets, leveraging our expertise and network to create
            opportunities and deliver value. We aim to be a catalyst for
            positive change, driving innovation and sustainable practices in
            each sector we operate in, and contributing to the betterment of
            communities and the world."
          </p>
        </div>
        <div className="flex justify-center lg:mt-20 mt-12">
          <div className="lg:w-[60%] w-full ">
            <ReactPlayer
              url={video}
              controls={false}
              loop
              playing
              playsinline={true}
              muted={true}
              className="video-container3"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Vision;
